import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  height: number;
}

export const Root = styled.div`
  height: ${(props: IRootProps) => props.height ? `${props.height}px` :  "100px"};
  font-family: Roboto;
  position: relative;
`;

export const SectionName = styled.div`
  font-size: 25px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  width: 100%;
`;

export const Container = styled.div`
  margin-top: 17px;
  display: flex;
  justify-content: space-between; 
`;

export const Slider = styled.div`
  width: inherit;
  display: inline-flex;
  gap: 10px;
`;

export const AddColor = styled.div`
    margin: 0px 9px 9px 0px;
    cursor: pointer;
    margin-right: 37px;
    &:hover svg rect {
      fill: ${C.GRAY};
    }
`;

export const SwipeableContainer = styled.div`
  padding: 0px 0px;
  width: calc(100% - 120px);
`

export const ViewAll = styled.div`
 font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  position: absolute;
  top: 0px;
  right: 18px;
  cursor: pointer;
`